<ng-container *ngIf="offerLetterTemplates">
    <!-- Form -->
    <form autocomplete="nope" #form="ngForm">
        <!-- Warning message if there are no offer letter templates -->
        <ui-banner *ngIf="offerLetterTemplates.length < 1" variant="warning" class="margin-y-2">
            <p>{{ 'offer-letter.warningMissingTemplate' | translate }}</p>
        </ui-banner>

        <p>{{ 'offer-letter.infoCandidate' | translate }}</p>

        <!-- First name -->
        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'offer-letter.firstName' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    name="firstName"
                    data-cy="firstName"
                    [(ngModel)]="offerLetter.legalFirstName"
                    #firstName="ngModel"
                />
                <mat-error *ngIf="firstName.invalid">{{ firstName.errors | formErrors }}</mat-error>
            </mat-form-field>

            <!-- Last name -->
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'offer-letter.lastName' | translate }}</mat-label>
                <input
                    matInput
                    type="text"
                    required
                    name="lastName"
                    data-cy="lastName"
                    [(ngModel)]="offerLetter.legalLastName"
                    #lastName="ngModel"
                />
                <mat-error *ngIf="lastName.invalid">{{ lastName.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>

        <!-- Email-->
        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'offer-letter.emailAddress' | translate }}</mat-label>
                <input
                    matInput
                    type="email"
                    required
                    name="email"
                    data-cy="offerLetterEmail"
                    emailValidator
                    [errorMessage]="'offer-letter.errorEmailAddressInUse' | translate"
                    [(ngModel)]="offerLetter.email"
                    #email="ngModel"
                />

                <mat-error *ngIf="email.invalid">
                    {{ email.errors.message ? email.errors.message : (email.errors | formErrors) }}
                </mat-error>
            </mat-form-field>
        </div>

        <!-- ReportsTo -->
        <div class="app-grid">
            <mat-form-field class="columns-4 small-columns-12">
                <mat-label>{{ 'offer-letter.reportsTo' | translate }}</mat-label>
                <ui-employee-autocomplete
                    name="reportsTo"
                    data-cy="reportsTo"
                    [(ngModel)]="offerLetter.reportsTo"
                    placeholder="{{ 'offer-letter.selectEmployee' | translate }}"
                    #reportsTo="ngModel"
                    [required]="false"
                ></ui-employee-autocomplete>
                <mat-error *ngIf="reportsTo.invalid">{{ reportsTo.errors | formErrors }}</mat-error>
            </mat-form-field>
        </div>
    </form>
</ng-container>
